import { ICategoryField } from "../../types";
import TextField from "@mui/material/TextField";
import { ReactElement } from "react";

interface IProps {
  data: ICategoryField;
  setData: (data: ICategoryField) => void;
  allowEdit: boolean;
}

const CustomConfigPanel = ({ data, setData, allowEdit }: IProps): ReactElement => {
  const onChange = (value: string) => {
    data.description = value;
    setData({ ...data });
  };

  return (
    <div className="p-1">
      <TextField
        label="Description"
        multiline={true}
        rows={4}
        value={data.description ?? ""}
        variant="standard"
        fullWidth={true}
        disabled={!allowEdit}
        onChange={e => onChange(e.target.value)}
      />
    </div>
  );
};

export default CustomConfigPanel;